import styled from 'styled-components'
import { media } from 'styles/media'

import ButtonMedium from '../../components/display/Button/Medium'
import SimpleLink from '../../components/display/SimpleLink'

export const CallToActionButton = styled(ButtonMedium)`
  letter-spacing: unset;
  text-transform: none;
  max-width: ${({ fullwidth }) => !fullwidth && 'fit-content'};
  font-size: ${({ theme }) =>
    theme?.['-ds-font-size-sm']?.['font-size']?.value};
  padding: 0 30px;

  ${media.md`
    font-size: ${({ theme }) =>
      theme?.['-ds-font-size-md']?.['font-size']?.value};
  `}

  margin: 0 auto;
  display: flex;
  align-items: center;
  justify-content: center;
`

export const LearnMoreLink = styled(SimpleLink)
  .withConfig({
    shouldForwardProp: (prop) => !['inverse'].includes(prop),
  })
  .attrs({
    textDecoration: 'none',
  })<{ inverse?: boolean }>`
  font-size: ${({ theme }) =>
    theme?.['-ds-font-size-sm']?.['font-size']?.value};

  color: ${({ theme, inverse }) =>
    inverse ? theme?.['-ds-core-200']?.value : theme?.['-ds-core-400']?.value};

  &:hover,
  &:visited,
  &:link {
    color: ${({ theme, inverse }) =>
      inverse
        ? theme?.['-ds-core-200']?.value
        : theme?.['-ds-core-400']?.value};
  }
`

export const Title = styled.h2`
  color: ${({ theme }) => theme?.['-ds-core-300']?.value};
  font-size: ${({ theme }) =>
    theme?.['-ds-font-size-lg']?.['font-size']?.value};
  font-weight: 400;
  line-height: 1.7;
  margin: 0;

  ${media.md`
    font-size: ${({ theme }) =>
      theme?.['-ds-font-size-xl']?.['font-size']?.value};
  `}
`

export const Subtitle = styled.h3`
  color: ${({ theme }) => theme?.['-ds-core-300']?.value};
  font-size: ${({ theme }) =>
    theme?.['-ds-font-size-sm']?.['font-size']?.value};
  font-weight: 300;
  line-height: 1.7;
  margin: 0 0 30px 0;
`
